import * as React from "react";
import { ZEntity } from "src/types/ZEntity";
import { StateView } from "src/components/StateView";

// Это конечно не очень удачное решение, но не хотелось дублировать или выносить функционал по отрисовке названия и состояния
import { entityCardStore } from "src/pages/EntityCardPage/EntityCardStore";
import { observer } from "mobx-react-lite";
import { Button, Dropdown, Input, MenuProps, Space, Switch } from "antd";
import { t } from "i18next";
import {
  ColumnHeightOutlined,
  DeleteOutlined,
  DownOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  ReloadOutlined,
  SearchOutlined,
  VerticalAlignMiddleOutlined,
} from "@ant-design/icons";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { ZUid } from "src/types/zUid";
import { ModalDelete } from "src/components/ModalDelete";
import { ColumnsSettings } from "src/components/tables/ColumnsSettings";
import { Planning2Table } from "./Planning2Table";
import { planning2ControlStore as store } from "./Planning2ControlStore";
import styles from "./Planning2Control.module.less";
import { Planning2NewTask } from "./Planning2NewTask";
import { Planning2NewTemplate } from "./Planning2NewTemplate";
import { Planning2CurrentTask } from "./Planning2CurrentTask";
import { Planning2Dates } from "./Planning2Dates";
import { Planning2Gantt } from "./Planning2Gantt";
import { ModalBadCalc } from "./ModalBadCalc";

type PropsPlanning2Control = {
  objectServiceId: ZUid;
  mainEntity: ZEntity;
};

export const Planning2Control: React.FC<PropsPlanning2Control> = observer(
  (props) => {
    const { mainEntity, objectServiceId } = props;
    React.useEffect(() => {
      store.init(objectServiceId, mainEntity.id).catch(onError);
    }, [mainEntity.id, objectServiceId]);
    const items: MenuProps["items"] = [
      {
        key: "new",
        label: "Новую задачу",
        icon: <PlusOutlined />,
        onClick: () => store.setMode("newTask"),
      },
      {
        key: "template",
        label: "Шаблон задач",
        icon: <PlusCircleOutlined />,
        onClick: () => store.setMode("newTemplate"),
      },
    ];
    const { tableStore } = store;
    const ctrlColumns = tableStore?.ctrlColumns;
    const gantt =
      store.data.status === "ready" ? store.data.result.gantt : undefined;

    return (
      <div className={styles.frame}>
        <div className={styles.header}>
          <div className={styles.title}>{entityCardStore.loadedEntityName}</div>
          <div className={styles.state}>
            <StateView name={entityCardStore.curStateName} />
          </div>
          {/* Вариант с одновременной поддержкой старого и нового варианта таблицы. Убрать, когда останется только новый.
          <Switch
            title="Use Gantt"
            value={store.useGantt}
            onChange={(v) => store.setUseGantt(v)}
            checkedChildren="Gantt"
            size="small"
          /> */}
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            loading={store.calculating}
            disabled={!store.canRecalcDates}
            title={store.msgRecalcDates}
            onClick={() => store.recalcDates()}
          >
            Рассчитать план
          </Button>
        </div>
        <Planning2Dates store={store.datesStore} />
        <div className={styles.toolbar}>
          <div className={styles.firstTool}>
            <Input
              style={{ width: "100%" }}
              prefix={<SearchOutlined />}
              placeholder={t("Search")}
              disabled={store.searchDisabled}
              allowClear
              value={store.search}
              onChange={(e) => store.setSearch(e.currentTarget.value)}
            />
          </div>
          {store.useGantt && ( // условие нужно убрать, а переклюсатель остаётся
            <label className={styles.ganttSwitchBox}>
              <Switch
                value={gantt?.showGantt}
                onChange={(v) => gantt?.changeShowGantt(v)}
              />
              <span>{t("Show Gantt")}</span>
            </label>
          )}
          <Button
            type="text"
            title="Раскрыть все группы"
            icon={<ColumnHeightOutlined />}
            disabled={!tableStore?.canExpandAll}
            onClick={() => tableStore?.expandAll()}
          />
          <Button
            type="text"
            title="Свернуть все группы"
            icon={<VerticalAlignMiddleOutlined />}
            disabled={!tableStore?.canCollapseAll}
            onClick={() => tableStore?.collapseAll()}
          />
          {!!ctrlColumns && <ColumnsSettings store={ctrlColumns} freezeLine />}
          <Button
            disabled={store.deleteDisabled}
            title={store.deleteTitle}
            danger
            icon={<DeleteOutlined />}
            onClick={() => store.setMode("delete")}
          >
            {t("Delete")}
          </Button>
          <Dropdown menu={{ items }} disabled={store.addDisabled}>
            <Button disabled={store.addDisabled}>
              <Space>
                {t("Add")} <DownOutlined />
              </Space>
            </Button>
          </Dropdown>
        </div>
        <div className={styles.tableBox}>
          <LoaderBox
            remoteData={store.data}
            drawReady={(data) =>
              store.useGantt ? (
                <Planning2Gantt gantt={data.gantt} />
              ) : (
                <Planning2Table data={data} />
              )
            }
          />
        </div>
        <ModalDelete
          open={store.mode === "delete"}
          onCancel={() => store.setMode(null)}
          message="Удалить выбранное?"
          extraContent="Удаление повлияет на плановые даты задач, в связи с удалением привязок задач."
          waiting={store.isDeleting}
          onOk={() => store.doDelete()}
        />
        <ModalBadCalc
          info={store.badCalc}
          close={() => store.setBadCalc(null)}
        />
        {!!store.settings && (
          <>
            <Planning2NewTask
              open={store.mode === "newTask"}
              close={() => store.setMode(null)}
              settings={store.settings}
              modelEntityId={mainEntity.id}
              objectServiceId={objectServiceId}
              onSuccess={() => store.onTaskFinish()}
            />
            <Planning2NewTemplate
              open={store.mode === "newTemplate"}
              close={() => store.setMode(null)}
              success={({ id }) => store.onTemplateFinish(id)}
              settings={store.settings}
            />
            <Planning2CurrentTask
              currentTask={tableStore?.currentTask}
              objectServiceId={objectServiceId}
              close={() => tableStore?.setCurrentTask(null)}
              reload={() => store.reload()}
              onDeleteSuccess={() => store.showDeleteMessage()}
            />
          </>
        )}
      </div>
    );
  },
);
